module.exports = __webpack_public_path__ + "static/savings-kampe-1ddf1b028ca19b2a6f4ec598d3bd4228.png";